import { useQuery } from "@tanstack/react-query";
import { SelectionOption } from "../types";

export type UseOptionsProps<TOption extends SelectionOption> = {
  getOptions: TOption[] | (() => TOption[]) | (() => Promise<TOption[]>); // TODO: debería aceptar opciones con tipo value distintos de number
};

export function useOptions<TOption extends SelectionOption>(
  props: UseOptionsProps<TOption>
) {
  const { getOptions } = props;

  const {
    data: options,
    isSuccess,
    isRefetching,
    isLoading,
  } = useQuery({
    queryKey: [
      // `select-${name}`,
      // ...(optionsDeps ?? [])
      // TODO: hay que tener en cuenta que si cambian las opciones,
      // hay que hacerle reset al hook form
    ],
    // staleTime: Infinity,
    // enabled: !loadOnOpen, // The query will be disabled if loadOnOpen is true.
    queryFn: () => {
      if (Array.isArray(getOptions)) {
        return Promise.resolve(getOptions);
      }

      const result = getOptions();

      if (Array.isArray(result)) {
        return Promise.resolve(result);
      }

      return result;
    },
  });

  return {
    options,
    isSuccess,
    isLoading: isLoading || isRefetching,
  };
}
